// 各种is

import os from '@edu-fe/os'

export const isxxx = {
  isWx: os.type === 'weixin',
  isApp: os.type === 'app',
  isWpsAndroid: os.type === 'app' && os.name === 'wps',
  isWpsIos: os.type === 'app' && os.name === 'wpsIos',
  isAppAndroid: os.type === 'app' && os.name === 'android',
  isAppIos: os.type === 'app' && os.name === 'ios',
  isInWps: os.type === 'app' && (os.name === 'wps' || os.name === 'wpsIos'),
  isInApp: os.type === 'app' && (os.name === 'android' || os.name === 'ios'),
  isInAllApps: os.type === 'app' || os.name === 'loan',
  isLoan: os.name === 'loan',
  isIos: !!(window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)),
  isAli: os.name === 'ali'
}

export default {
  data () {
    return { ...isxxx }
  }
}
